module.exports = __webpack_public_path__ + "images/a9f516339d2f6b90da49353b284064a3-profile_overlay.jpg";